import AppLayout from '@/layout/AppLayout.vue'
const manageRouter = // 管理端
	{
		path: '/manage',
		component: AppLayout,
		children: [{
				path: '/orderImport',
				name: 'orderImport',
				select: false,
				component: () => import('@/manage/orderImport/index'),
				meta: {
					title: '批量下单',
					icon: 'table'
				}
			},
			{
				path: '/shipments',
				name: 'shipments',
				select: false,
				component: () => import('@/manage/shipments/index'),
				meta: {
					title: '我的订单',
					icon: 'table'
				}
			},
			{
				path: '/billing',
				name: 'billing',
				select: false,
				component: () => import('@/manage/billing/index'),
				meta: {
					title: '我的账单',
					icon: 'table'
				}
			},
			{
				path: '/produce',
				name: '我的设置',
				select: true,
				component: AppLayout,
				redirect: '/produce',
				meta: {
					title: '我的设置',
					icon: 'table'
				},
				children: [{
						path: '',
						name: 'profile',
						component: () => import('@/manage/produce/index'),
						meta: {
							title: '我的设置',
							icon: 'table'
						},
						hidden: true
					},
					{
						path: '/commodities',
						name: 'commodities',
						component: () => import('@/manage/produce/commodities/index'),
						meta: {
							title: '我的商品',
							icon: 'table'
						}
					},
					{
						path: '/CompanyProfile',
						name: 'CompanyProfile',
						component: () => import('@/manage/produce/companyProfile/index'),
						meta: {
							title: '公司信息',
							icon: 'table'
						}
					},
					{
						path: '/AccountDetails',
						name: 'AccountDetails',
						component: () => import('@/manage/produce/accountDetails/index'),
						meta: {
							title: '账户信息',
							icon: 'table'
						}
					},
					{
						path: '/AddressDetails',
						name: 'AddressDetails',
						component: () => import('@/manage/produce/addressDetails/index'),
						meta: {
							title: '地址库信息',
							icon: 'table'
						}
					}
				]
			}
			//   {
			//     path:'/commodities',
			//     name:'商品管理',
			//     component:()=>import('@/manage/produce/commodities/index'),
			//     meta:{
			//         title: "用户中心",
			//         icon: "table",
			//     }
			//   },
		]
	}

export default manageRouter